import { setGeneralDetails } from 'redux/actions';
import store from 'redux/store';
import { history } from '.';
const ChangeHistory = (action, path, id = '') => {
	switch (action) {
		case 'push':
			store.dispatch(
				setGeneralDetails({
					screenClass: 'fadeOutLeft',
				}),
			);
			setTimeout(() => {
				store.dispatch(
					setGeneralDetails({
						screenClass: '',
					}),
				);
			}, 250);
			break;

		case 'back':
			document.body.className = 'disabled';
			store.dispatch(
				setGeneralDetails({
					screenClass: 'fadeOutRight',
				}),
			);
			setTimeout(() => {
				store.dispatch(
					setGeneralDetails({
						screenClass: '',
					}),
				);
			}, 250);
			break;

		default:
			break;
	}
	setTimeout(() => {
		document.body.className = '';
		path ? history.push({ pathname: path, state: id }) : history.goBack();
		if (action === 'back' && path) {
			store.dispatch(
				setGeneralDetails({
					screenClass: 'fadeInLeft',
				}),
			);
		}
	}, 250);
};

export default ChangeHistory;
